import { SVGFC } from '@repo/toolkit/types'

const PdfIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.55566 17.3999V15.1499M7.55566 15.1499V13.7999C7.55566 13.376 7.55566 13.1636 7.69255 13.0313C7.82943 12.8999 8.04898 12.8999 8.48896 12.8999H9.11115C9.75557 12.8999 10.2782 13.4039 10.2782 14.0249C10.2782 14.6459 9.75557 15.1499 9.11115 15.1499H7.55566ZM19.9996 12.8999H18.8334C18.1001 12.8999 17.733 12.8999 17.5055 13.1195C17.2779 13.3391 17.2779 13.6928 17.2779 14.4002V15.1499M17.2779 15.1499V17.3999M17.2779 15.1499H19.2218M15.3331 15.1499C15.3331 16.3919 14.2887 17.3999 12.9999 17.3999C12.7092 17.3999 12.5643 17.3999 12.455 17.3396C12.1964 17.1956 12.2221 16.9031 12.2221 16.6502V13.6496C12.2221 13.3967 12.1955 13.1042 12.455 12.9602C12.5634 12.8999 12.7092 12.8999 12.9999 12.8999C14.2887 12.8999 15.3331 13.9079 15.3331 15.1499Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6662 21H10.8681C7.97049 21 6.51989 21 5.51371 20.2818C5.22737 20.0785 4.97142 19.8345 4.75375 19.5573C4 18.5979 4 17.2173 4 14.4543V12.1638C4 9.4971 4 8.1633 4.41687 7.0986C5.08706 5.3859 6.50389 4.0359 8.30115 3.3969C9.41754 3 10.8157 3 13.6156 3C15.2137 3 16.0137 3 16.6519 3.2268C17.6785 3.5922 18.4883 4.3635 18.8714 5.3418C19.1105 5.9502 19.1105 6.7125 19.1105 8.2362V10.2"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12C4 11.2044 4.31212 10.4414 4.86771 9.87889C5.42329 9.31634 6.17682 9.0003 6.96254 9.0003C7.55451 9.0003 8.25226 9.1047 8.82735 8.949C9.07863 8.88053 9.30772 8.74637 9.49165 8.55997C9.67558 8.37358 9.80789 8.1415 9.8753 7.887C10.0291 7.3047 9.92596 6.5982 9.92596 5.9988C9.9262 5.20339 10.2384 4.44063 10.794 3.87827C11.3495 3.31592 12.1029 3 12.8885 3"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PdfIcon
